// ErrorBoundary — catches render/lifecycle errors below it so one broken view shows a
// readable card (with the actual error text) instead of white-screening the whole app.
import { Component } from "react";

export default class ErrorBoundary extends Component {
  constructor(props) {
    super(props);
    this.state = { error: null };
  }

  static getDerivedStateFromError(error) {
    return { error };
  }

  componentDidCatch(error, info) {
    console.error("UI error:", error, info?.componentStack);
  }

  render() {
    if (!this.state.error) return this.props.children;
    return (
      <div className="uierror">
        <h3>⚠ {this.props.title || "Something broke"}</h3>
        <p className="uierror__msg">{String(this.state.error?.message || this.state.error)}</p>
        <div className="uierror__row">
          <button className="btn btn--primary" onClick={() => window.location.reload()}>Reload</button>
          {this.props.onClose && (
            <button className="btn btn--soft"
              onClick={() => { this.setState({ error: null }); this.props.onClose(); }}>
              Close
            </button>
          )}
        </div>
      </div>
    );
  }
}
